import { Link as RouterLink, useLocation } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';
import { DASHBOARD_PATH } from '../../../config';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const location = useLocation();
    return (
        <Link component={RouterLink} to={DASHBOARD_PATH}>
            <Logo />
        </Link>
    );
};

export default LogoSection;
